const bgColors = [
  { name: "ff-white", value: "#ffffff" },
  { name: "ff-light-grey", value: "#eeeeee" },
  { name: "ff-alice-blue", value: "#f4f7fb" },
  { name: "ff-grey", value: "#d3d3d3" },
  { name: "ff-dark-grey", value: "#6c6c6c" },
  { name: "ff-black", value: "#000000" },
]

export { bgColors };